import React, { useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Fade from 'react-reveal/Fade';
import ScrollSpyMenu from 'src/common/components/ScrollSpyMenu';
import Scrollspy from 'react-scrollspy';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { x } from 'react-icons-kit/feather/x';
import Logo from 'src/common/components/UIElements/Logo';
import Button from 'src/common/components/Button';
import Container from 'src/common/components/UI/Container';
import NavbarWrapper, { MenuArea, MobileMenu } from './navbar.style';

const Navbar = () => {
  const data = useStaticQuery(graphql`
    query {
      appChristmasJson {
        navbar {
          logo {
            publicURL
          }
        }
      }
    }
  `);

  const { logo } = data.appChristmasJson.navbar;
  const [state, setState] = useState({
    mobileMenu: false,
  });

  const toggleHandler = (type) => {
    if (type === 'menu') {
      setState({
        ...state,
        mobileMenu: !state.mobileMenu,
      });
    }
  };

  const scrollItems = [];

  return (
    <NavbarWrapper className="navbar">
      <Container>
        <Logo
          href="/assistant"
          logoSrc={logo.publicURL}
          title="App Assistant"
          className="main-logo"
        />
        {/* end of logo */}
      </Container>
    </NavbarWrapper>
  );
};

export default Navbar;
